import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

const TableHeader = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cell
  }, /*#__PURE__*/React.createElement("span", null, "BATTLE ID")), /*#__PURE__*/React.createElement("div", {
    className: styles.cell
  }, /*#__PURE__*/React.createElement("span", null, "MODE")), /*#__PURE__*/React.createElement("div", {
    className: styles.cell
  }, /*#__PURE__*/React.createElement("span", null, "RESULT")), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.cell, styles.rewards)
  }, /*#__PURE__*/React.createElement("span", null, "Rewards")), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.cell, styles.time)
  }, /*#__PURE__*/React.createElement("span", null, "TIME")));
};

export default TableHeader;